var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewMember(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.615,
    height: 11.143,
    viewBox: "0 0 18.615 11.143",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "view",
    transform: "translate(0.254 -16.23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14681",
    "data-name": "Group 14681",
    transform: "translate(0 16.43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11514",
    "data-name": "Path 11514",
    d: "M17.784,21.387c-.158-.2-3.929-4.957-8.73-4.957S.482,21.185.323,21.387L0,21.8l.323.414c.158.2,3.929,4.958,8.731,4.958s8.572-4.755,8.73-4.958l.323-.414Zm-8.73,4.441c-3.377,0-6.325-2.924-7.316-4.027.992-1.1,3.939-4.027,7.316-4.027S15.378,20.7,16.37,21.8C15.378,22.9,12.43,25.828,9.054,25.828Z",
    transform: "translate(0 -16.43)",
    fill: "#363a4a",
    stroke: "#363a4a",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11515",
    "data-name": "Path 11515",
    d: "M27.66,23.983a3.679,3.679,0,1,0,3.679,3.679A3.683,3.683,0,0,0,27.66,23.983Zm0,6.013a2.334,2.334,0,1,1,2.334-2.335A2.337,2.337,0,0,1,27.66,30Z",
    transform: "translate(-18.606 -22.29)",
    fill: "#363a4a",
    stroke: "#363a4a",
    strokeWidth: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewMember);
export default __webpack_public_path__ + "static/media/viewMember.02844714.svg";
export { ForwardRef as ReactComponent };